// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"102":"xlsx","133":"pdfmake","182":"canvg"}[chunkId] + "." + {"102":"72498aff","133":"bfc00791","182":"a4da7f19"}[chunkId] + ".chunk.js";
};